import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	IMtdEmReportsItem,
	TMtdReportsItemResponsePayload,
	TMtdStore,
	TUpdateObligationsResponse,
	THmrcManualProcessing,
} from './types';

// ==========================================:
const getMtdState = (state: TStoreState): TMtdStore => state.mtd;
export const getMtd = createSelector([getMtdState], (mtd: TMtdStore) => mtd);

// ====================================================:
export const getMtdReportsLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.mtdReportsIsLoading,
);

// ====================================================:
export const getMtdReports = createSelector(
	[getMtd],
	(mtd: TMtdStore): TMtdReportsItemResponsePayload<IMtdEmReportsItem> => mtd.mtdReports,
);

// ====================================================:

export const getMtdReportLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.mtdReportIsLoading,
);

// ====================================================:

export const getMtdReport = createSelector(
	[getMtd],
	(mtd: TMtdStore): IMtdEmReportsItem | null => mtd.mtdReport,
);

// ====================================================:

export const getCalculateMtdDataLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.calculateMtdDataIsLoading,
);

// ====================================================:

export const getDownloadMtdReportPdfLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.downloadMtdReportPdfIsLoading,
);

// ====================================================:

export const getUpdateObligationsLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.updateObligationsIsLoading,
);

// ====================================================:

export const getUpdateObligationsResponse = createSelector(
	[getMtd],
	(mtd: TMtdStore): TUpdateObligationsResponse | null => mtd.updateObligationsResponse,
);

// ====================================================:

export const getEmLastMtdReports = createSelector(
	[getMtd],
	(mtd: TMtdStore): TMtdReportsItemResponsePayload<IMtdEmReportsItem> => mtd.emLastMtdReports,
);

export const getEmLastMtdReportsLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.emLastMtdReportsIsLoading,
);

// ====================================================:

export const getManualProcessing = createSelector(
	[getMtd],
	(mtd: TMtdStore): THmrcManualProcessing | null => mtd.manualProcessing,
);

export const getManualProcessingLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.manualProcessingIsLoading,
);

export const getUpdateManualProcessingLoad = createSelector(
	[getMtd],
	(mtd: TMtdStore): boolean => mtd.updateManualProcessingIsLoading,
);
